import {ConfirmDialog} from '@wallaby-ui/core';
import PropTypes from 'prop-types';
import * as React from 'react';

import stylesAutoLayout from '../AutoLayout.less';
import LastChangeAuthor from '../LastChangeAuthor';
import SavableComponentContainer from '../SavableComponentContainer';
import styles from './ArrayScreenWrapper.less';
import ArrayScreenWrapperAddButton from './ArrayScreenWrapperAddButton';
import ArrayScreenWrapperRemoveButton from './ArrayScreenWrapperRemoveButton';
import {ScreenError} from 'src/js/containers/auto_layout/components';
import AutoLayoutService from 'src/js/lib/auto_layout/auto_layout_service';
import {ContentComponent} from 'src/js/model/auto_layout_content_schema';
import {LayoutComponent} from 'src/js/model/auto_layout_layout_schema';
import {MetadataSchema} from 'src/js/model/auto_layout_metadata_schema';
import {KEYWORD_DATA_ITEMS} from 'src/js/model/auto_layout_screen_data_helpers';

class ArrayScreenWrapper extends React.PureComponent {
  static isItemDisabled(props, item) {
    const {contextParams, readOnly, screenId, screenProperties} = props;
    const itemScreenId = AutoLayoutService.getItemScreenId(screenId, item);
    const indexScreenId = AutoLayoutService.getIndexScreenId(
      screenId,
      contextParams
    );
    return (
      readOnly ||
      screenProperties[indexScreenId].isInvalid ||
      (screenProperties[itemScreenId] &&
        (screenProperties[itemScreenId].isLoading ||
          screenProperties[itemScreenId].isSaving ||
          screenProperties[itemScreenId].isRemoving ||
          screenProperties[itemScreenId].isInvalid))
    );
  }

  constructor() {
    super();
    this.handleRemove = this.handleRemove.bind(this);

    this.savableCompElems = {};
  }

  handleRemove(item) {
    // call remove of savable component
    if (this.savableCompElems[item]) {
      let component = this.savableCompElems[item];
      while (
        component &&
        !component.handleDelete &&
        component.getWrappedInstance
      ) {
        component = component.getWrappedInstance();
      }
      if (component.handleDelete) {
        component.handleDelete(undefined);
      }
    }
  }

  render() {
    const {
      autoLayoutStateId,
      config,
      configStateId,
      confirmText,
      conflictLastChangeAuthor,
      contextParams,
      errors,
      expanded,
      index,
      isItemLoaded,
      itemContent,
      itemLayout,
      metadata,
      onAdd,
      onConfirm,
      onCancelConfirm,
      onReload,
      onRemove,
      onSave,
      readOnly,
      screenId,
      screenProperties,
      screenStyles,
      showConfirm,
      textOnly,
    } = this.props;
    const indexScreenId = AutoLayoutService.getIndexScreenId(
      screenId,
      contextParams
    );
    const {isEditing} = screenProperties[indexScreenId];
    return screenProperties[indexScreenId] &&
      !screenProperties[indexScreenId].isLoading ? (
      <div className={styles.dlArrayScreenWrapper}>
        <ConfirmDialog
          isOpened={showConfirm}
          handleConfirm={onConfirm}
          handleCancel={onCancelConfirm}
          showCancel={false}
        >
          {confirmText}
          {conflictLastChangeAuthor ? (
            <>
              <hr className={stylesAutoLayout.dlHRInFlexBoxFix} />
              <LastChangeAuthor name={conflictLastChangeAuthor} />
            </>
          ) : null}
        </ConfirmDialog>
        <div>
          <ScreenError errors={errors} />
        </div>
        <div className={styles.dlArrayScreenWrapperContent}>
          <ArrayScreenWrapperAddButton
            isDisabled={readOnly || screenProperties[indexScreenId].isInvalid}
            onAdd={onAdd}
          />
          {index[KEYWORD_DATA_ITEMS].slice(0)
            .reverse()
            .map((item) => (
              <div
                className={stylesAutoLayout.dlSavableComponentWrapper}
                style={{...screenStyles}}
                key={item}
              >
                {isEditing ? (
                  <ArrayScreenWrapperRemoveButton
                    isDisabled={ArrayScreenWrapper.isItemDisabled(
                      this.props,
                      item
                    )}
                    item={item}
                    onRemove={this.handleRemove}
                  />
                ) : null}
                <SavableComponentContainer
                  ref={(savableCompElem) => {
                    this.savableCompElems[item] = savableCompElem;
                  }}
                  id={item}
                  isSaved={isItemLoaded(item)}
                  isIndexInvalid={screenProperties[indexScreenId].isInvalid}
                  autoLayoutStateId={autoLayoutStateId}
                  config={config}
                  configStateId={configStateId}
                  contextParams={contextParams}
                  content={itemContent}
                  layout={itemLayout}
                  metadata={metadata}
                  screenId={`${screenId}.${item}`}
                  readOnly={readOnly}
                  textOnly={textOnly}
                  expanded={expanded}
                  onSave={onSave}
                  onReload={onReload}
                  onRemove={onRemove}
                />
              </div>
            ))}
        </div>
      </div>
    ) : null;
  }
}

ArrayScreenWrapper.displayName = 'ArrayScreenWrapper';

ArrayScreenWrapper.propTypes = {
  autoLayoutStateId: PropTypes.string.isRequired,
  config: PropTypes.objectOf(PropTypes.any).isRequired,
  configStateId: PropTypes.string.isRequired,
  confirmText: PropTypes.string,
  conflictLastChangeAuthor: PropTypes.string,
  contextParams: PropTypes.objectOf(PropTypes.any).isRequired,
  errors: PropTypes.objectOf(PropTypes.any),
  index: PropTypes.objectOf(PropTypes.any).isRequired,
  itemContent: PropTypes.instanceOf(ContentComponent).isRequired,
  itemLayout: PropTypes.instanceOf(LayoutComponent).isRequired,
  metadata: PropTypes.instanceOf(MetadataSchema).isRequired,
  screenId: PropTypes.string.isRequired,
  readOnly: PropTypes.bool,
  showConfirm: PropTypes.bool,
  textOnly: PropTypes.bool,
  expanded: PropTypes.bool,
  screenProperties: PropTypes.objectOf(PropTypes.any),
  screenStyles: PropTypes.objectOf(PropTypes.any),
  onAdd: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancelConfirm: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onReload: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  isItemLoaded: PropTypes.func.isRequired,
};

ArrayScreenWrapper.defaultProps = {
  confirmText: '',
  conflictLastChangeAuthor: '',
  errors: undefined,
  screenProperties: undefined,
  screenStyles: undefined,
  readOnly: false,
  showConfirm: false,
  textOnly: false,
  expanded: false,
};

export default ArrayScreenWrapper;
